/**
 * At start-up App asks /auth/user whether the business is onboarded. When the
 * server says it is but the in-memory user (read from the cached copy in
 * localStorage) still says it is not — onboarding was finished on another
 * device, or the flag changed while this tab was open — the in-memory user must
 * be replaced. Otherwise the app keeps treating a live business as onboarding
 * for the whole session: the footer stays hidden on Ingredient Reconciliation,
 * Sales Name Check and Verification, and Item Map opens in mapping mode (W-5).
 *
 * Replace only when they disagree: setUser hands App a new object, `user` is a
 * dependency of the start-up effect, and an unconditional call re-runs it
 * forever. This only ever moves a session OUT of onboarding mode; the opposite
 * case (server says not onboarded) is App's own branch.
 */
const parseBooleanLike = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') {
    if (value === 1) return true;
    if (value === 0) return false;
    return null;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true' || normalized === '1' || normalized === 't') return true;
    if (normalized === 'false' || normalized === '0' || normalized === 'f') return false;
  }
  return null;
};

export const shouldAdoptOnboardedUser = (inMemoryUser, backendOnboarded) => backendOnboarded === true
  && parseBooleanLike(inMemoryUser?.isOnboarded ?? inMemoryUser?.is_onboarded) !== true;
